module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.groups !== null) ? _c('div', {
    staticClass: "grid",
    attrs: {
      "id": "group-board"
    }
  }, [_c('ul', {
    staticClass: "col-2"
  }, _vm._l((_vm.groups.slice().reverse()), function(group) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": ("/group/" + (group.uid) + "/")
      }
    }, [_vm._v(_vm._s(group.name))])], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e6e5a56"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/GroupBoard.vue
// module id = 583
// module chunks = 0